/**
 * Validates whole form.
 */
Nette.isValid = function (sender) {
    const form = sender.form || sender;


    let scope = false;

    if (form['nette-submittedBy'] && form['nette-submittedBy'].getAttribute('formnovalidate') !== null) {
        const scopeArr = Nette.parseJSON(form['nette-submittedBy'].getAttribute('data-nette-validation-scope'));
        if (scopeArr.length) {
            scope = new RegExp(`^(${scopeArr.join('-|')}-)`);
        } else {
            return true;
        }
    }

    const radios = {}; let i; let
        elem;

    for (i = 0; i < form.elements.length; i++) {
        elem = form.elements[i];
        let cont = false;

        if (elem.tagName && !(elem.tagName.toLowerCase() in {
            input: 1, select: 1, textarea: 1, button: 1,
        })) {
            cont = true;
        } else if (elem.type === 'radio') {
            if (radios[elem.name]) {
                cont = true;
            }
            radios[elem.name] = true;
        }

        if (!cont && ((scope && !elem.name.replace(/]\[|\[|]|$/g, '-').match(scope)) || Nette.isDisabled(elem))) {
            cont = true;
        }

        if (!cont && !Nette.validateControl(elem, null, true)) {
            return false;
        }
    }
    return true;
};

/**
 * @param elem
 * @param {string[]} args Min and max allowed value (e.q. [0 => "2018-10s-12T10:56:09", 1 => "2018-11-12T10:56:09"])
 * @param {string} val Value from input (e.q. "21.09.2018 12:33")
 * @returns {boolean}
 * @constructor
 */
Nette.validators.TrigamaFormsValidator_dateRange = function (elem, args, val) {
    // parse date in format d.m.Y H:s (e.q. "21.09.2018 12:33")
    const dateParsed = val.match(/^(\d{2})\.(\d{2})\.(\d{4}) (\d{2}):(\d{2})$/);

    if (dateParsed === null) {
        return false;
    }

    const min = args[0] !== undefined ? new Date(args[0]) : null;
    const max = args[1] !== undefined ? new Date(args[1]) : null;

    const selectedDate = new Date(dateParsed[3], parseInt(dateParsed[2]) - 1, dateParsed[1], dateParsed[4], dateParsed[5]);

    return (min === null || min < selectedDate) && (max === null || selectedDate < max);
};

/**
 * @param elem
 * @param {string[]} args Min and max allowed value (e.q. [0 => "2018-10s-12T10:56:09", 1 => "2018-11-12T10:56:09"])
 * @param {string} val Value from input (e.q. "21.09.2018 12:33")
 * @returns {boolean}
 * @constructor
 */
Nette.validators.TrigamaFormsValidator_dateMin = function (elem, args, val) {
    // parse date in format d.m.Y H:s (e.q. "21.09.2018 12:33")
    const dateParsed = val.match(/^(\d{2})\.(\d{2})\.(\d{4}) (\d{2}):(\d{2})$/);

    if (dateParsed === null) {
        return false;
    }

    let minDate = null;
    if (args[0] !== undefined) {
        const minParsed = args[0].match(/^(\d{2})\.(\d{2})\.(\d{4}) (\d{2}):(\d{2})$/);
        if (minParsed !== null) {
            minDate = new Date(minParsed[3], parseInt(minParsed[2]) - 1, minParsed[1], minParsed[4], minParsed[5]);
        } else {
            minDate = new Date(args[0]);
        }
    }
    const min = minDate;

    const selectedDate = new Date(dateParsed[3], parseInt(dateParsed[2]) - 1, dateParsed[1], dateParsed[4], dateParsed[5]);

    return min === null || min < selectedDate;
};

/**
 * @param elem
 * @param {string[]} args
 * @param {string} val Value from input (e.q. "21.09.2018 12:33")
 * @returns {boolean}
 * @constructor
 */
Nette.validators.TrigamaFormsValidator_dateUnique = function (elem, args, val) {
    allDates = document.querySelectorAll('input[date-unique]');
    let counter = 0;
    for (let i = 0; i < allDates.length; i++) {
        if (allDates[i].value === val) {
            counter += 1;
        }

        if (counter > 1) {
            return false;
        }
    }

    return true;
};

//  Override default float validator for million numbers with many spaces as separator
Nette.validators.float = function (elem, arg, val, value) {
    if (elem.type === 'number' && elem.validity.badInput) {
        return false;
    }
    val = val.replace(/ /g, '');
    val = val.replace(',', '.');
    if ((/^-?[0-9]*[.,]?[0-9]+$/).test(val)) {
        value.value = val;
        return true;
    }
    return false;
};
